import githubIcon from "../images/github.png";
import instagramIcon from "../images/instagram.png";
import linkedinIcon from "../images/linkedin.png";

const social_list = [
  {
    icon: githubIcon,
    altName: "github",
    link: "https://github.com/vtyeh",
  },
  {
    icon: linkedinIcon,
    altName: "linkedin",
    link: "https://www.linkedin.com/in/venessayeh/",
  },
  // {
  //   icon: opolIcon,
  //   altName: "opol",
  //   link: "https://opol.space/@venessa",
  // },
  {
    icon: instagramIcon,
    altName: "instagram",
    link: "https://www.instagram.com/cozypetals.pixels/",
  },
];

export default function Social() {
  return (
    <div className={"contactLinks"}>
      {social_list.map((social, index) => (
        <a key={index} href={social.link} target="_blank" rel="noreferrer">
          <img
            src={social.icon}
            alt={social.altName}
            className={"socialIcon"}
          />
        </a>
      ))}
    </div>
  );
}
